export default "__VITE_ASSET__PZN4VTu9__"